import PropTypes from 'prop-types';

function LessonsLearnedLeafIcon({ offsetX, offsetY }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform={`translate(${offsetX},${offsetY})`}
    >
      <path
        d="M11.3259 0L15.4044 0.0174C15.5624 0.017453 15.7139 0.0802618 15.8256 0.192012C15.9373 0.303762 16 0.455301 16 0.6133V12.9293C16 13.0872 15.9373 13.2387 15.8257 13.3504C15.7141 13.4622 15.5627 13.525 15.4048 13.5252L11.3263 13.5078C10.652 13.509 10.0036 13.7676 9.51363 14.2308C9.19101 14.5358 8.95309 14.9143 8.81705 15.3295C8.69742 15.6946 8.38984 16 8.00564 16C7.6214 16 7.31381 15.6945 7.19419 15.3294C7.05821 14.9143 6.82039 14.5359 6.4979 14.2309C6.00804 13.7677 5.35978 13.5091 4.6856 13.5078H0.5956C0.437601 13.5077 0.286094 13.4449 0.1744 13.3332C0.0627059 13.2214 -2.65192e-05 13.0699 0 12.9119V0.5959C-2.65192e-05 0.437901 0.0627059 0.286362 0.1744 0.174612C0.286094 0.0628618 0.437601 5.30353e-05 0.5956 0H4.6853C5.30628 8.92501e-05 5.91871 0.144783 6.47407 0.42262C7.02943 0.700456 7.51246 1.1038 7.8849 1.6007L8.0049 1.7607L8.1249 1.6014C8.49748 1.10426 8.98071 0.700718 9.53632 0.422757C10.0919 0.144796 10.7046 5.43028e-05 11.3259 0Z"
        fill="#63EFFF"
      />
      <rect x="7" y="3" width="2" height="10" rx="1" fill="#212121" />
    </svg>
  );
}

LessonsLearnedLeafIcon.propTypes = {
  offsetX: PropTypes.number,
  offsetY: PropTypes.number,
};

LessonsLearnedLeafIcon.defaultProps = {
  offsetX: 0,
  offsetY: 0,
};

export default LessonsLearnedLeafIcon;
